import { render, staticRenderFns } from "./ResultTestDetailChild.vue?vue&type=template&id=d5741de6&scoped=true"
import script from "./ResultTestDetailChild.vue?vue&type=script&lang=js"
export * from "./ResultTestDetailChild.vue?vue&type=script&lang=js"
import style0 from "./ResultTestDetailChild.vue?vue&type=style&index=0&id=d5741de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5741de6",
  null
  
)

export default component.exports